import { createContext } from 'react';

var DialogBackdropContext = createContext(undefined);

export { DialogBackdropContext as D };
